import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { UserService } from 'app/services/user.service';
import { ReportService } from 'app/services/report.service';
import { LookupExternalCollection, ReportSpecType, VehicleClass } from 'app/utility/enums';
import { ReportSpecModel } from 'app/models/dms/reportSpec.model';
import { GeneralService } from 'app/services/general.service';
import { Constants } from 'app/utility/constants';
import { LookupExternalModel } from 'app/models/shared/lookup.model';

@Component({
    selector: 'app-text-library',
    templateUrl: './text-library.component.html',
    styleUrls: ['./text-library.component.scss'],
    standalone: false
})
export class TextLibraryComponent implements OnInit {

    @Input() lookup: LookupExternalCollection;
    @Input() reportSpecType: ReportSpecType;

    public skeleton: boolean = false;

    emailTextLibraryItems: ReportSpecModel[] = [];
    smsTextLibraryItems: LookupExternalModel[] = [];


    constructor(
        private modalController: ModalController,
        private reportService: ReportService,
        public userService: UserService,
        private generalService: GeneralService,
        private alertController: AlertController

    ) { }

    ngOnInit() {
        this.fetchObject();
    }

    dismissTheModal() {
        this.modalController.dismiss({
            result:
            {

            }
        });
    }

    public fetchObject() {
        this.skeleton = true;
        if (this.lookup)
        {
            this.generalService.getExternalLookups(VehicleClass.None, this.lookup, Constants.EmptyGuid)
                .subscribe({
                    next: async lookupItems =>
                    {
                        this.smsTextLibraryItems = lookupItems;
                        this.skeleton = false;
                    },
                    error: err =>
                    {
                        this.skeleton = false;
                        this.userService.handleError(err);
                    }
                });
        }
        else if (this.reportSpecType)
        {
            this.reportService.getCachedReportSpecs(this.reportSpecType)
                .subscribe({
                    next: async specs =>
                    {
                        this.emailTextLibraryItems = specs;
                        this.skeleton = false;
                        
                    },
                    error: err =>
                    {
                        this.skeleton = false;
                        this.userService.handleError(err);
                    }
                });
        }
        else
        {
            this.userService.handleError("No lookup or report spec type provided to text library component.");
            this.dismissTheModal();
        }

    }

    selectEmailItem(item: ReportSpecModel)
    {
        this.modalController.dismiss({
            result: {
                selectedItem: item
            }
        });
    }

    selectSmsItem(item: LookupExternalModel)
    {
        this.modalController.dismiss({
            result: {
                selectedItem: item
            }
        });
    }

    async addItem()
    {
        if (!this.lookup)
        {
            return;
        }

        const alert = await this.alertController.create({
            header: 'Add to text library',
            inputs: [
                {
                    type: 'text',
                    name: 'reference',
                    label: 'Reference',
                    placeholder: 'Reference'
                },
                {
                    type: 'textarea',
                    name: 'specialCondition',
                    label: 'Special condition',
                    placeholder: 'Special condition'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Add',
                    handler: ({ reference, specialCondition }) =>
                    {
                        const trimmedReference = reference?.trim();
                        const trimmedSpecialCondition = specialCondition?.trim();
                        if (!trimmedReference || !trimmedSpecialCondition)
                        {
                            return false;
                        }

                        this.generalService.findOrCreateExternalLookup(
                            trimmedReference,
                            VehicleClass.None,
                            this.lookup,
                            Constants.EmptyGuid,
                            '',
                            '',
                            '',
                            trimmedSpecialCondition
                        ).subscribe({
                            next: item =>
                            {
                                item.caption = item.caption || trimmedReference;
                                item.description = item.description || trimmedSpecialCondition;
                                this.smsTextLibraryItems = [...this.smsTextLibraryItems, item];
                                this.selectSmsItem(item);
                            },
                            error: err => this.userService.handleError(err)
                        });
                    }
                }
            ]
        });

        await alert.present();
    }

}
